export async function shopifyFetch(query, variables = {}) {
	const res = await fetch('https://e75t1a-vk.myshopify.com/api/2025-04/graphql.json', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Shopify-Storefront-Access-Token': '94177bd0cb74cfe481435be48beaac6f'
		},
		body: JSON.stringify({ query, variables })
	});

	const json = await res.json();
	if (json.errors) console.error(json.errors);
	return json.data;
}
